import * as React from "react";
import LabelHybrid from "./LabelHybrid";
import type { TypeLabelProps } from "./LabelTypes";

/**
 * Label component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or styled() extension).
 */
const Label = (props: TypeLabelProps) => <LabelHybrid {...props} />;

export default Label;
